import type { ComponentChildren } from 'preact'
import { styled } from '../setup'
import { colors, spacing } from '../theme'

const Container = styled('div')`
  min-height: 100vh;
  background: ${colors.bgPage};
  box-shadow: inset 0 0 120px rgba(0,0,0,0.04);
`

const Content = styled('main')`
  padding: ${spacing['2xl']};
`

interface AppLayoutProps {
  children: ComponentChildren
}

export function AppLayout({ children }: AppLayoutProps) {
  return (
    <Container>
      <Content>{children}</Content>
    </Container>
  )
}
